export function commonNonEmptyValue(
  values: ReadonlyArray<string | null | undefined>,
): string | null {
  if (values.length === 0 || values.some(value => !value?.trim())) return null;
  const first = values[0]!;
  return values.every(value => value === first) ? first : null;
}
